import DebugGame from "./DebugGame.tsx";
import "./App.css";
import GameScene from "./GameScene";


function App() {
  return (
    <div className="cap-main-page">
      <div className="cap-main-game-code-hint-area">
        <div className="cap-main-game-hint-area">
          <GameScene />
        </div>
        <div className="cap-main-code-editor-area">
          <DebugGame></DebugGame>
        </div>
      </div>

    </div>
  );
}

export default App;
